import axios from "axios";
import Storage from '@/tools/Storage'
import { ElMessage,ElLoading, progressProps } from 'element-plus';
import Router from "./Router";
 
const http=axios.create({
    baseURL:"/storeadminapi", //生产
    // baseURL:"/api",
    timeout:60000,
     headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    }
   
});
let loading=null;
http.interceptors.request.use(
    config=>{
       
      loading=ElLoading.service({
        lock:true,
        text:"正在请求服务器...",
        background:'rgba(0,0,0,.6)'
      })
      //添加token
      let token=sessionStorage.getItem("token");
      config.headers.token=token;
      return config;
    },
    error=>{
        return Promise.reject(error);
    }
    
);

http.interceptors.response.use(
    response=>{
        loading.close();
        const data=response.data;
        if(data.status==3){//判断用户token检验，报错需要重新登陆
            Storage.commit('clearUserInfo');
            ElMessage({
                message:data.msg, 
                type:'error', 
                duration:3000
            })
            setTimeout(() => {
                Router.push({name:"login"})
            }, 3000);
            
        }
        return response.data
    },
    error=>{
        loading.close();
        return Promise.reject(error);
    }


)

export default http;
